import { Checkbox as PrimereactCheckbox } from 'primereact/checkbox';
import { ReactComponent as CheckSmall } from '../../assets/images/check_small.svg';

const Checkbox = ({showLabel = true, label, labelOnRight = true, ...rest}) => {
    const id = `cb-${rest.id}`;
    return (
        <div className='flex align-items-center' id={rest.id}>
            <PrimereactCheckbox id={id} {...rest} icon={<CheckSmall />}/>
            {showLabel && labelOnRight && <label htmlFor={id} className="ml-2 checkbox-label">{label}</label>}
        </div>
    )
}

export default Checkbox;